export default __webpack_public_path__ + "static/media/Group9250.1c40a52d.svg";